import { Category } from './types';

export const transformCategory = (response: any): Category => ({
  id: response.id,
  name: response.data.name,
});
